

export const REPOST_PAYMENT_TRANSACTION_REQUESTED = 'repostPayment/REPOST_PAYMENT_TRANSACTION_REQUESTED';
export const REPOST_PAYMENT_TRANSACTION_SUCCESS = 'repostPayment/REPOST_PAYMENT_TRANSACTION_SUCCESS';
export const REPOST_PAYMENT_TRANSACTION_FAILURE = 'repostPayment/REPOST_PAYMENT_TRANSACTION_FAILURE';
export const RESET_REPOST_PAYMENT_TRANSACTIONS = 'repostPayment/RESET_REPOST_PAYMENT_TRANSACTIONS';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  repostPaymentTransactions: [],
};

export default(state = initialState, action) => {
  switch (action.type) {
    case REPOST_PAYMENT_TRANSACTION_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case REPOST_PAYMENT_TRANSACTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        repostPaymentTransactions: action.result
      };
    }
    case REPOST_PAYMENT_TRANSACTION_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case RESET_REPOST_PAYMENT_TRANSACTIONS: {
      return {
        ...state,
        repostPaymentTransactions: []
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const repostPaymentTransaction = (data) => {
  return {
    types: [REPOST_PAYMENT_TRANSACTION_REQUESTED, REPOST_PAYMENT_TRANSACTION_SUCCESS, REPOST_PAYMENT_TRANSACTION_FAILURE],
    promise: client => client.post('repostPaymentTransaction', { data })
  };
};

export const resetRepostPaymentTransactions = () => {
  return {
    type: RESET_REPOST_PAYMENT_TRANSACTIONS,
    payload: [],
  };
};
